import { render, staticRenderFns } from "./ShowIrRemote.vue?vue&type=template&id=1adb9d6b"
import script from "./ShowIrRemote.vue?vue&type=script&lang=js"
export * from "./ShowIrRemote.vue?vue&type=script&lang=js"
import style0 from "./ShowIrRemote.vue?vue&type=style&index=0&id=1adb9d6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports